import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getUserDeleteObjectProps {
  t: TranslateService;
  store?: any; // Replace 'any' with UserRepository if available
  representation?: string | number;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getUserDeleteObject = ({ t, store, representation, action, toggleVisiblity }: getUserDeleteObjectProps): DialogObject => {
  return {
    title: t.instant('settings.user.deleteUser.title', { representation: representation }),
    description: t.instant('settings.user.deleteUser.description', { representation: representation }),
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
